module.exports = __webpack_public_path__ + "assets/img/mecha-85946f34.png";